<template>
  <div>
    <transition name="fade">
      <div v-if="isReady" key="main" class="home-main">
        <Header></Header>
        <HomeView></HomeView>
        <Schedule></Schedule>
        <Profile></Profile>
        <Work></Work>
        <Discography></Discography>
        <Lesson></Lesson>
        <Contact></Contact>
        <Footer></Footer>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { ref, onMounted } from "vue"
  import Header from "../../components/header/Header.vue"
  import HomeView from "../../components/homeview/HomeView.vue"
  import Schedule from "../../components/schedule/Schedule.vue"
  import Profile from "../../components/profile/Profile.vue"
  import Work from "../../components/work/Work.vue"
  import Discography from "../../components/discography/Discography.vue"
  import Lesson from "../../components/lesson/Lesson.vue"
  import Contact from "../../components/contact/Contact.vue"
  import Footer from "../../components/footer/Footer.vue"

  const isReady = ref(false)

  onMounted(() => {
    // サイト訪問後に一度フェードインを再生したら、以降の再訪(戻る操作等)では即表示する
    if (window.__topIntroPlayed) {
      isReady.value = true
      return
    }

    const markReady = () => {
      isReady.value = true
      window.__topIntroPlayed = true
    }

    if (document.readyState === "complete") {
      markReady()
    } else {
      window.addEventListener("load", markReady, { once: true })
    }
  })
</script>

<style lang="scss" src="./style.scss"></style>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
    position: absolute;
  }
  .fade-enter-to,
  .fade-leave-from {
    opacity: 1;
    position: static;
  }

  .home-main span {
    transition: transform 0.3s ease-in-out;
    display: inline-block;
  }

  .home-main span.shine {
    transform: scale(1.2);
    color: #ffcc00;
    text-shadow: 0 0 10px #ffcc00;
  }
</style>
